import type { Subject } from '../../models/Subject';
import type { SupabaseClient } from 'jsr:@supabase/supabase-js@2';
import { SupabaseRepository } from '../supabaseRepository/SupabaseRepository.ts';

const selector = `id, name, class_id, created_at`;

export class SubjectRepository extends SupabaseRepository<Subject> {
  constructor(client: SupabaseClient) {
    super('subjects', selector, client);
  }
}
